/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'object',
      properties: {
        value: {
          type: 'string',
          enum: ['BY_THE_FAC', 'BY_3RD_PARTY_AGENTS', 'BOTH', 'OTHER'],
        },
        followUp: {
          type: ['object', 'null'],
          properties: {
            value: {
              type: 'string',
            },
          },
          required: ['value'],
        },
      },
      required: ['value', 'followUp'],
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    are_wrkrs_paid_directly_by_the_fac_or_through_3rd_party_agents: valueSchema,
  },
}
